import { FormikErrors, FormikTouched } from "formik";
import React from "react";
import UserInfoApi, { UserReferenceResponse } from "../../../../api/services/UserInfoApi";
import { AutocompleteSelectable } from "../../../../components/Autocomplete/CustomSearchAutoComplete";
import {
  UsersSearchMultipleAutocomplete, //
} from "../../../../components/Autocomplete/CustomSearchAutoComplete.instances";
import InfoBox from "../../../../components/InfoBox";
import useEnv from "../../../../hooks/env";
import DescriptionFormType from "../models/Description.form";

const infoText = "Enter other colleagues interested in the test request.";
export interface InternalContactInputProps {
  autoFocus?: boolean;
  disabled: boolean;
  errors: FormikErrors<DescriptionFormType>;
  handleDirtyChange: () => void;
  mandatory?: boolean;
  setFieldValue: (field: string, value: unknown, shouldValidate?: boolean) => void;
  touched: FormikTouched<DescriptionFormType>;
  values: DescriptionFormType;
}

const InternalContactInput: React.FC<InternalContactInputProps> = (props) => {
  const { autoFocus, disabled, errors, handleDirtyChange, mandatory, setFieldValue, touched, values } = props;
  const { api } = useEnv();
  const userInfoApi = new UserInfoApi(api);

  const helperText =
    errors.furtherInternalContacts && touched.furtherInternalContacts ? errors.furtherInternalContacts : "";

  const legacyValues = values.furtherInternalContact && {
    groups: [],
    userName: values.furtherInternalContact,
    userId: values.furtherInternalContact,
    userEmail: values.furtherInternalContact,
    laboratories: [],
    assignedLaboratories: [],
    managedLaboratories: [],
  };

  const valuesPrepended = legacyValues
    ? [legacyValues, ...(values.furtherInternalContacts || [])]
    : values.furtherInternalContacts;

  const changeTagColor = (index: number) => {
    return !!(index === 0 && values.furtherInternalContact);
  };

  const getDeleteFirstTag = (item: AutocompleteSelectable<UserReferenceResponse>, index: number) => {
    if (index === 0 && values.furtherInternalContact) {
      return {
        onDelete: () => {
          setFieldValue("furtherInternalContact", "");
        },
      };
    }
  };

  return (
    <InfoBox text={infoText}>
      <UsersSearchMultipleAutocomplete
        autoFocus={!!autoFocus}
        disabled={disabled}
        mandatory={mandatory}
        error={!!(errors.furtherInternalContacts && touched.furtherInternalContacts)}
        helperText={typeof helperText === "string" ? helperText : undefined}
        inputLabel="Further Internal Contact"
        placeholder="Add User"
        map={(value): { key: string; label: string } => ({
          key: `${value.userId}`,
          label: `${value.userName}`,
        })}
        onChange={(event, newUsers): void => {
          const lastItem = newUsers[newUsers.length - 1];
          const noLegacyVals = legacyValues ? newUsers.slice(1) : newUsers;
          if (
            noLegacyVals.length <= (values.furtherInternalContacts || []).length ||
            !(values.furtherInternalContacts || []).some((user) => user.userId === lastItem.userId)
          ) {
            setFieldValue("furtherInternalContacts", noLegacyVals);
            handleDirtyChange();
          }
        }}
        optionFetch={(query) => userInfoApi.getAllUsers(query).then(({ data }) => data)}
        getCustomTagDelete={getDeleteFirstTag}
        tagColorSecondary={changeTagColor}
        value={valuesPrepended}
      />
    </InfoBox>
  );
};

export default InternalContactInput;
